export const ENABLE_NEW_TEMPLATE_CONTENT = true;
export const DISABLE_OLD_TEMPLATE_CONTENT = true;
export const USE_SCHEMA_V2_WITH_GRADIENTJ = true;

export const ENABLE_INACTIVITY_LOGOUT = true;
export const ENABLE_TEMPLATE_VALIDATION_BEFORE_SIGNING = true;

export const SUPPORT_GOING_BACK_FROM_SESSION_REVIEW = true;
export const OPEN_NOTE_FROM_CALENDAR_IN_THE_SAME_TAB = true;
export const ADD_NOTE_IN_CALENDAR_REDIRECTS_TO_SESSION_REVIEW = true;

export const ENABLE_PREBUILT_TEMPLATES = true;
export const ENABLE_CHART_NOTES = true;

export const ENABLE_VOICE_AI = false;

export const INCLUDE_INITIALS_IN_NOTE_FILE_NAMES = true;

export const ENABLE_BULK_DOWNLOAD = true;
export const ENABLE_VIDEO_CALL_WAITING_ROOM = true;
export const TRANSCRIBE_VIDEO_WITH_DEEPGRAM = true;
export const ENABLE_WHITEBOARD = false;
export const RECORD_TELEHEALTH_AUDIO = false;

export const ENABLE_MERGE_CLIENTS = false;
export const ENABLE_SWITCH_CLIENT_TYPE = false;
export const ENABLE_FAMILY_TAG = false;
export const ENABLE_MULTIPLE_CLINICIANS = false;

export const ENABLE_PUBNUB_S3_HYBRID_HISTORY = true;
